import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Item from 'modules/timeoff/components/Leaves/PolicyAssignments/_Item'
import type { PolicyTimelineItem } from 'modules/timeoff/store/models/TimeoffPolicy/PolicyTimeline'

interface Props {
  employeeId: number
  currentAssignmentId: number
  selectedTimelineItem: PolicyTimelineItem | null | undefined
  timelineItems: PolicyTimelineItem[]
  onSelectTimelineItem: (item: PolicyTimelineItem) => void
  fetchTimeline: () => Promise<void>
}

const List = ({
  employeeId,
  currentAssignmentId,
  timelineItems,
  selectedTimelineItem,
  onSelectTimelineItem,
  fetchTimeline,
}: Props) => {
  return (
    <Box gap="s16" padding="s16">
      {timelineItems.map((item: PolicyTimelineItem) => (
        <Item
          employeeId={employeeId}
          key={item.policy_assignment_id}
          current={item.policy_assignment_id === currentAssignmentId}
          last={timelineItems[0] === item}
          selected={item.policy_assignment_id === selectedTimelineItem?.policy_assignment_id}
          timelineItem={item}
          onSelectTimelineItem={onSelectTimelineItem}
          fetchTimeline={fetchTimeline}
        />
      ))}
    </Box>
  )
}

export default observer(List)
